import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CloseIcon from "@material-ui/icons/Close";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

// Data
import menudata from "../../data/menu.json";
import Logo from "../../images/Logo Hengel.png";

const useStyles = makeStyles((theme) => ({
  mobileWrapper: {
    height: "65px",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  logowrapper: {
    position: "absolute",
    top: "20px",
    left: "20px",
    width: "100px",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  list: {
    width: "40vw",
    [theme.breakpoints.down("xs")]: {
      width: "70vw",
    },
  },
  fullList: {
    width: "auto",
  },
  menu: {
    position: "absolute",
    right: "0px",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  open: {
    color: "#666666",
  },
  drawer: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  button: {
    justifyContent: "flex-end",
    textAlign: "end",
  },
}));

export default function MobileMenu() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
      <ListItem button key={menudata.Menu[0].slug} className={classes.button}>
            <a className="uppercase" href="#leistungen">

            <b>{menudata.Menu[0]}</b></a>
        </ListItem>

        {menudata.Submenu.map((item) => (
          <ListItem
            button
            key={item.name}
            className={classes.button}
            style={{ borderBottom: "1px solid #f7f7f7" }}
          >
            <Link to={item.slug}>{item.name}</Link>
          </ListItem>
        ))}
        <ListItem button key={menudata.Menu[1].slug} className={classes.button}>
          <Link className="uppercase" to={menudata.Menu[1].slug}>
            <b>{menudata.Menu[1].name}</b>
          </Link>
        </ListItem>



        <ListItem button key={menudata.Menu[2].slug} className={classes.button}>
          <Link className="uppercase" to={menudata.Menu[2].slug}>
            <b>{menudata.Menu[2].name}</b>
          </Link>
        </ListItem>
        <ListItem button key={menudata.Menu[3].slug} className={classes.button}>
        <Link className="uppercase" to={menudata.Menu[3].slug}>
            <b>{menudata.Menu[3].name}</b>
          </Link>
        </ListItem>
        <ListItem button key={menudata.Menu[4].slug} className={classes.button}>
        <Link className="uppercase" to={menudata.Menu[4].slug}>
            <b>{menudata.Menu[4].name}</b>
          </Link>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Grid className={classes.mobileWrapper}  id="back-to-top-anchor-mobile"   >
      <Link to="/">
        <img
          src={Logo}
          alt="Firma Hengel Logo"
          className={classes.logowrapper}
        />
      </Link>
      <Grid className={classes.menu} >
        {["right"].map((anchor) => (
          <React.Fragment key={anchor}>
            <IconButton
              aria-label="open drawer"
              onClick={toggleDrawer(anchor, true)}
              className={classes.open}
            >
              <MenuIcon fontSize="large" />
            </IconButton>

            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              className={classes.drawer}
            >
              <IconButton
                style={{ color: "#666666", justifyContent: "flex-end" }}
                aria-label="open drawer"
                onClick={toggleDrawer(anchor, false)}
              >
                <CloseIcon />
              </IconButton>
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
}
